
import React from 'react';
import './Spinner.css';

const Spinner = ({ size = 'medium', color = '#007bff' }) => {
    return (
        <div className={`spinner-container spinner-${size}`}>
            <div
                className="spinner"
                style={{ borderTopColor: color }}
            ></div>
        </div>
    );
};

export default Spinner;